import { fetchGuestWishlist } from '@app/services/lookbookRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { Lookbook, ShowroomApiResponse } from '@typings';
import { AxiosError } from 'axios';

export const LOOKBOOK_WISHLIST_BY_ID_QUERY_KEY = 'lookbookWishlistById';

interface Props {
  refetchOnMount?: boolean;
  lookbookId: Nullable<string> | undefined;
  wishlistId: Nullable<string> | undefined;
}

export const useLookbookWishlist = ({ lookbookId, wishlistId, refetchOnMount }: Props) => {
  const isEnabled = isDefined(lookbookId) && isDefined(wishlistId);

  return useQuery<ShowroomApiResponse & Lookbook.WishlistResponse, AxiosError, Lookbook.WishlistDTO>({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => fetchGuestWishlist(lookbookId, wishlistId) : skipToken,
    queryKey: [LOOKBOOK_WISHLIST_BY_ID_QUERY_KEY, lookbookId, wishlistId],
    refetchOnMount,
    select: data => ({ ...data, products: data.products.map(v => v.toString()) }),
  });
};
